
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AttachmentDto, FpUpdateUsageMetricDto } from 'webcommon/shared';
import { FacilityPortalHttpClientService } from '../FacilityPortalHttpClientService';

@Injectable({
  providedIn: 'root',
})
export class FacilityVisitRepository {

  constructor(
    private httpClientService: FacilityPortalHttpClientService,
  ) { }

  getPdfByVisit(visitId: string, patientId: string): Observable<AttachmentDto> {
    const endpointUrl = `patients/${patientId}/visit/${visitId}/pdf`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  postUsageMetricUpdate(updateUsageMetricDto: FpUpdateUsageMetricDto): Observable<void>  {
    const endpointUrl = `usage-metric/metric-update`;
    return this.httpClientService.sendPostRequest(endpointUrl, updateUsageMetricDto);
  }
}
